import styled from 'styled-components'

import Link from '../../../../global/Link'

export const StyledHeader = styled.h2`
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  font-size: 24px;
  color: #001b36;
  margin-bottom: 8px;
`

export const StyledDescription = styled.p`
  && {
    font-family: ${({ theme }) => theme.fontFamilies.roboto};
    font-size: 16px;
    color: #001b36;
    margin-bottom: 0;
  }
`

export const StyledSmallHeader = styled.h5`
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  text-transform: uppercase;
  margin-top: 36px;
`

export const StyledSmallParagraph = styled.p`
  color: ${({ theme }) => theme.colors.coolGray.cool600};
  font-size: 14px;
`

export const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.colors.royalBlue.shade500};
`

export const StyledInformationIcon = styled.img`
  display: block;
  width: 16px;
  height: 16px;
  margin-right: 10px;
  margin-top: 20px;
`

export const StyledContainer = styled.div`
  display: flex;
`
